import { Polling } from "./polling.js";
import { WS } from "./websocket.js";
export var transports = {
  websocket: WS,
  polling: Polling
};